export default __webpack_public_path__ + "static/media/Untitled4.6c37f5fb.jpg";